export default __webpack_public_path__ + "static/euro-eaf7367ef815e5f46014d3e172f52eb8.gif";